// extracted by mini-css-extract-plugin
export var infoRow = "_sb-2";
export var labelContainer = "_sb-0";
export var rightInfo = "_sb-1";